import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@knockrentals/knock-shared-web-v2';
import { DividedTabSection } from '../../TabSections';
import { Branding } from './Branding';
import PropertyWebsite from './PropertyWebsite';
import { Social } from './Social';
import { SECTIONS } from '../../constants';
import { MARKETING_MEDIA_FIELDS } from '../constants';

const { DESCRIPTION, TITLE } = SECTIONS.MARKETING_MEDIA;
const { CUSTOM_LINKS, PROPERTY_WEBSITE, SOCIAL_MEDIA } = MARKETING_MEDIA_FIELDS;

const MarketingMedia = ({
  clearFieldErrorMessage,
  marketingMedia,
  updateMarketingMedia,
  validationErrorMessages,
}) => {
  const { brandColor, logos = [], photos = [] } = marketingMedia || {};

  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      <Flex flexDirection="column" gap={24}>
        <PropertyWebsite
          clearFieldErrorMessage={clearFieldErrorMessage}
          propertyWebsite={marketingMedia[PROPERTY_WEBSITE]}
          updateMarketingMedia={updateMarketingMedia}
          validationErrorMessage={validationErrorMessages[PROPERTY_WEBSITE]}
        />

        <Branding
          brandColor={brandColor}
          logos={logos}
          photos={photos}
          updateMarketingMedia={updateMarketingMedia}
        />

        <Social
          clearFieldErrorMessage={clearFieldErrorMessage}
          customLinks={marketingMedia[CUSTOM_LINKS]}
          socialMedia={marketingMedia[SOCIAL_MEDIA]}
          updateMarketingMedia={updateMarketingMedia}
          validationErrorMessages={validationErrorMessages}
        />
      </Flex>
    </DividedTabSection>
  );
};

MarketingMedia.propTypes = {
  clearFieldErrorMessage: PropTypes.func,
  marketingMedia: PropTypes.shape({
    logos: PropTypes.arrayOf(
      PropTypes.shape({
        clUrl: PropTypes.string,
        thumbUrl: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        clUrl: PropTypes.string,
        thumbUrl: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
  }),
  updateMarketingMedia: PropTypes.func,
  validationErrorMessages: PropTypes.objectOf(PropTypes.string),
};

export default MarketingMedia;
